Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SocialContentDetailsView extends Backbone.View
  className: 'sc-details'

  initialize: ({@model}) ->
    undefined

  render: ->
    @_renderTimestamp()
    @_renderTopics()
    @

  _renderTimestamp: ->
    @$el.append new Monitoring.Views.SocialContents.SocialContentDetailsTimestampView(
      timestamp: Date.create @model.created_at()
    ).render().el

  _renderTopics: ->
    @$el.append new Monitoring.Views.SocialContents.SocialContentDetailsTopicsView(
      topics: @model.getTopicsName()
    ).render().el
